import React , { Fragment } from "react";
import BusinessCardPreviewer from "./BusinessCardPreviewer";
import Sidebar from "./Sidebar";
import styled from "styled-components";
import {connect} from 'react-redux';
import {setMode} from '../actions';
import Toolbar from './Toolbar';
import selectors from '../selectors';
import { components as SnackbarComponents } from '../../SnackBar';
import { components as LoadingIndicatorComponents , actions , selectors as loadingSelectors } from '../../LoadingIndicator';
import LoadingIndicatorReducer from "../../LoadingIndicator/reducer";

const { LoadingIndicator } = LoadingIndicatorComponents;

const { showLoadingIndicator , hideLoadingIndicator } = actions;

const { getShouldDisplayLoadingIndicator } = loadingSelectors;

const { Notifier } = SnackbarComponents;

const { getEditorSettings } = selectors;

const BuilderContainer = styled.div`
  position: relative;
  height: 100%;
`;

const BuilderLayout = styled.div`
  display: grid;
  grid-template-columns: 70% 30%;
  grid-template-rows: 50 auto;
  grid-template-areas:
  'header sidebar'
  'content sidebar';
  background-color: #2e3b47;
  min-height: 100%;
`;

const BuilderItem = styled.div`
  grid-column-start: ${(props) => props.columnStart ? props.columnStart : 'auto'};
  grid-column-end: ${(props) => props.columnStart ? props.columnEnd : 'auto'};
  grid-row-start: ${(props) => props.rowStart ? props.rowStart : 'auto'};
  grid-row-end: ${(props) => props.rowEnd ? props.rowEnd : 'auto'};
  grid-area: ${(props) => props.area ? props.area : 'auto / auto / auto / auto'}
`;

function CardBuilder({editorSettings,showLoadingIndicator}) {

  return (
    <BuilderContainer>
      <BuilderLayout>
        <BuilderItem area={"header"}>
          <Toolbar/>
        </BuilderItem>
        <BuilderItem area={"sidebar"}>
          <Sidebar/>
        </BuilderItem>
        <BuilderItem area={"content"}>
          <BusinessCardPreviewer previewResolution={editorSettings.previewResolution}/>
        </BuilderItem>
      </BuilderLayout>
     <LoadingIndicator loading={showLoadingIndicator}/>
      <Notifier/>
    </BuilderContainer>
  );
}


const mapStateToProps = state => ({
  editorSettings: getEditorSettings(state),
  showLoadingIndicator: getShouldDisplayLoadingIndicator(state)
});

const mapDispatchToProps = dispatch => ({
  setMode: mode => dispatch(setMode(mode)),
});

export default connect(mapStateToProps,mapDispatchToProps)(CardBuilder);
